export default "__VITE_ASSET__DZADoDxB__"